import * as ElementPlusIcons from '@element-plus/icons-vue'
import { h } from 'vue'

/** Element UI 图标类名 → Element Plus Icons 组件名（非常规命名） */
const ICON_NAME_OVERRIDES = {
  'el-icon-s-home': 'House',
  'el-icon-office-building': 'OfficeBuilding',
  'el-icon-location-outline': 'Location',
  'el-icon-location-information': 'LocationInformation',
  'el-icon-edit-outline': 'EditPen',
  'el-icon-document-copy': 'DocumentCopy',
  'el-icon-video-camera': 'VideoCamera',
  'el-icon-picture-outline': 'Picture',
  'el-icon-folder-opened': 'FolderOpened',
  'el-icon-user-solid': 'UserFilled',
  'el-icon-arrow-down': 'ArrowDown',
  'el-icon-arrow-up': 'ArrowUp',
  'el-icon-arrow-left': 'ArrowLeft',
  'el-icon-arrow-right': 'ArrowRight',
  'el-icon-d-arrow-left': 'DArrowLeft',
  'el-icon-d-arrow-right': 'DArrowRight',
  'el-icon-circle-plus-outline': 'CirclePlus',
  'el-icon-remove-outline': 'Remove',
  'el-icon-warning-outline': 'Warning',
  'el-icon-s-operation': 'Operation',
  'el-icon-s-grid': 'Grid',
  'el-icon-s-check': 'Select',
  'el-icon-s-data': 'DataAnalysis',
  'el-icon-s-tools': 'Tools',
  'el-icon-s-flag': 'Flag',
  'el-icon-s-order': 'List',
  'el-icon-s-goods': 'Goods',
  'el-icon-s-marketing': 'Promotion',
  'el-icon-s-management': 'Management',
  'el-icon-s-cooperation': 'Connection',
  'el-icon-s-platform': 'Platform',
  'el-icon-s-promotion': 'Promotion',
  'el-icon-s-claim': 'Checked',
  'el-icon-s-finance': 'Money',
  'el-icon-s-comment': 'ChatDotRound',
  'el-icon-s-custom': 'Avatar',
  'el-icon-s-opportunity': 'Opportunity',
  'el-icon-s-release': 'Upload',
  'el-icon-s-fold': 'Fold',
  'el-icon-s-unfold': 'Expand',
  'el-icon-s-shop': 'Shop',
  'el-icon-s-open': 'Open',
  'el-icon-message-solid': 'Message',
  'el-icon-star-on': 'StarFilled',
  'el-icon-star-off': 'Star',
  'el-icon-phone-outline': 'Phone',
  'el-icon-more-outline': 'More',
  'el-icon-upload2': 'Upload',
  'el-icon-download': 'Download',
  'el-icon-picture-outline-round': 'PictureRounded',
  'el-icon-video-camera-solid': 'VideoCameraFilled',
  'el-icon-camera-solid': 'CameraFilled',
  'el-icon-delete-solid': 'DeleteFilled',
  'el-icon-circle-check': 'CircleCheck',
  'el-icon-circle-close': 'CircleClose',
  'el-icon-circle-plus': 'CirclePlusFilled',
  'el-icon-bangzhu': 'QuestionFilled',
  'el-icon-c-scale-to-original': 'ScaleToOriginal',
}

function kebabToPascal(kebab) {
  return kebab
    .split('-')
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join('')
}

function resolveComponentName(legacyClass) {
  if (!legacyClass || typeof legacyClass !== 'string') return null
  const trimmed = legacyClass.trim()
  if (ICON_NAME_OVERRIDES[trimmed]) return ICON_NAME_OVERRIDES[trimmed]
  if (!trimmed.startsWith('el-icon-')) return null
  const suffix = trimmed.slice('el-icon-'.length)
  return kebabToPascal(suffix)
}

const fallbackIconCache = Object.create(null)

/** 将 el-icon-* 类名解析为 Element Plus 图标组件；无映射时回退字体图标 */
export function resolveLegacyIcon(legacyClass) {
  const componentName = resolveComponentName(legacyClass)
  if (componentName && ElementPlusIcons[componentName]) {
    return ElementPlusIcons[componentName]
  }
  const cacheKey = typeof legacyClass === 'string' ? legacyClass : ''
  if (!fallbackIconCache[cacheKey]) {
    fallbackIconCache[cacheKey] = {
      name: 'LegacyFontIcon',
      props: { class: { type: String, default: cacheKey } },
      render() {
        return h('i', { class: this.class || cacheKey })
      },
    }
  }
  return fallbackIconCache[cacheKey]
}

export function registerElementPlusIcons(app) {
  for (const [key, component] of Object.entries(ElementPlusIcons)) {
    app.component(key, component)
  }
}

export { ElementPlusIcons }
